//these are functions and variables that will be used across every detail metric
//you can make updates here that will reflect on all metrics


export const handleSiteInDropDown = (allSites) => {
    let sites = [];
    Object.keys(allSites).forEach(site => {
        sites.push({value: site, name: allSites[site]})
    });
    return sites
};

export const handleCountriesInDropDown = (allCountries) => {
    let countries = [];

    Object.keys(allCountries).forEach(country => {
        countries.push({value: country, name: allCountries[country]})
    });

    return countries
};

export const handleDevicesInDropDown = (allDevices)=> {
    let devices = [];

    allDevices.map(device=>{
        return devices.push({ value: device , name: device });
    });

    return devices;
};

export const handleEmbedsInDropDown = (allEmbeds)=> {
    let embeds = [];

    Object.keys(allEmbeds).forEach(embed => {
        return embeds.push({value: embed, name: allEmbeds[embed]})
    });

    return embeds;
};

export const handleStoriesInDropDown = (allStories) => {
    let stories = [];

    Object.keys(allStories).forEach(story => {
        return stories.push({value: story, name: allStories[story]})
    });

    return stories;
};

export const tooltipHelper = (revenueType) => revenueType ? revenueType === 'VIDEO' ? 'Video Ad' : 'Display Ad' : 'Display and Video Ad';
